export default __webpack_public_path__ + "static/media/badaIndex.2a3e42c8.gif";